// React and related imports
import React, { useEffect } from 'react';

// Icons
import { HiCheck, HiX } from 'react-icons/hi';

// Redux hooks and selectors
import { useAppSelector } from '../../../redux/hooks/useAppSelector';
import { useAppDispatch } from '../../../redux/hooks/useAppDispatch';
import { selectIsRTL } from '../../../redux/selectors/displaySettingsSelectors';

// Redux slices
import { removeToast } from '../../../redux/slices/toastSlice';

// Framer motion
import { AnimatePresence, motion } from 'framer-motion';

export const Toast: React.FC = () => {
  const dispatch = useAppDispatch();
  const isRtl = useAppSelector(selectIsRTL);
  const toasts = useAppSelector((state) => state.toast.toasts);

  useEffect(() => {
    const timers = toasts?.map((toast) =>
      setTimeout(() => {
        dispatch(removeToast(toast.id));
      }, 3000)
    );
    return () => {
      timers.forEach(clearTimeout);
    };
  }, [toasts]);

  return (
    <div
      className={`fixed bottom-5 z-[9999] flex flex-col gap-3 ${
        isRtl ? 'left-4' : 'right-4'
      }`}
    >
      <AnimatePresence>
        {toasts?.map((toast) => (
          <motion.div
            key={toast.id}
            role={toast.type === 'success' ? 'status' : 'alert'}
            initial={{ opacity: 0, x: isRtl ? -50 : 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: isRtl ? -50 : 50 }}
            transition={{ duration: 0.3 }}
            className={`flex w-fit min-w-[200px] items-center rounded-lg px-4 py-3 text-sm shadow-lg transition-all duration-300 ${
              toast.type === 'success'
                ? 'bg-green-500 text-white'
                : 'bg-red-500 text-white'
            }`}
          >
            <span className="me-2">
              {toast.type === 'success' ? (
                <div className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-lg bg-green-100 text-green-500 dark:bg-green-800 dark:text-green-200">
                  <HiCheck className="h-4 w-4" />
                </div>
              ) : (
                <div className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-lg bg-red-100 text-red-500 dark:bg-red-800 dark:text-red-200">
                  <HiX className="h-4 w-4" />
                </div>
              )}
            </span>
            <span>{toast.message}</span>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};
